/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 17:03:58
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-03 19:11:42
 * @Description: file content
 */

Vue.component("vue_loading", {
  props: {
    img_url: String,
    is_show_tips: Boolean
  },
  template: `<div>
		<div class="share-container-mask">
			<div class="loading-container">
				<div class="loading-box">
					<div class="lds-spinner">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
				<div class="loading-tips">生成中···</div>
			</div>
		</div>
  </div>`,
  data() {
    return {
    }
  },
  created() {
  }
})
